import { useEffect, useState } from 'react';
import type { Target } from '@shared/protocol';
import { api } from './api';

let cache: Target[] | null = null;
let pending: Promise<Target[]> | null = null;
const listeners = new Set<(t: Target[]) => void>();

export function reloadTargets(): Promise<Target[]> {
  pending = api<{ targets: Target[] }>('GET', '/api/targets').then((r) => {
    cache = r.targets;
    pending = null;
    for (const l of listeners) l(r.targets);
    return r.targets;
  });
  return pending;
}

/** Presets and platform profiles, loaded once and shared. */
export function useTargets(): Target[] {
  const [targets, setTargets] = useState<Target[]>(cache ?? []);
  useEffect(() => {
    listeners.add(setTargets);
    if (!cache && !pending) void reloadTargets().catch(() => {});
    else if (pending) void pending.then(setTargets).catch(() => {});
    return () => {
      listeners.delete(setTargets);
    };
  }, []);
  return targets;
}
